<template>
  <div>
    <iframe class="privacy-box" :src="src"></iframe>
  </div>
  <!-- <div class="textBox">{{ Text }}</div> -->
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/bengreenvietnamcompanylimited/vn/components/img/1_1.png";
import importedImg2 from "@/page/bengreenvietnamcompanylimited/vn/components/img/1_2.png";
import importedImg3 from "@/page/bengreenvietnamcompanylimited/vn/components/img/1_3.png";
import importedImg4 from "@/page/bengreenvietnamcompanylimited/vn/components/img/1_4.png";
import importedImg5 from "@/page/bengreenvietnamcompanylimited/vn/components/img/1_5.png";
// import importedImg6 from "@/page/bengreenvietnamcompanylimited/vn/components/img/1_6.png";
// import importedImg7 from "@/page/bengreenvietnamcompanylimited/vn/components/img/1_7.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      // importedImg6: importedImg6,
      // importedImg7: importedImg7,
      altText: "图片",
      src:"https://tim.nhdinvestment.com/N9s1tM6t/t8YdV7P5a.html",
      Text: ``,
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  margin: 0;
}

.img5Box {
  margin-top: 50px;
}
.textBox{
  color:#333333;
  white-space: pre-wrap;
}
.privacy-box{
  width: 100%;
  height: 100vh;
  border: 0;
}
</style>
